import JwtToken from './jwt-token'
import store from '../store';
import axios from 'axios'

axios.interceptors.request.use(function (config) {
  let token = localStorage.getItem('token');
  if(token) {
    config.headers.token = token.substr(1, token.length - 2)
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

axios.interceptors.response.use(
  data => data
, (responseError) => {
  console.log('error inteceptor => ', JSON.stringify(responseError))
  if(responseError.response && responseError.response.status === 401 || responseError.response.status === 403) {
    let email = localStorage.getItem('usuario'), password = localStorage.getItem('password');
    JwtToken.accessToken(email, password).then(async (res) => {
      store.commit('setToken', res.data);
      responseError.config.headers.token = res.data.token;
      await axios.request(responseError.config);
      window.location.reload(true);
    })
  }
  return Promise.reject(responseError);
});



// WEBPACK FOOTER //
// ./src/services/interceptors.js